
import setAllExternalLinksToTargetBlank from './utilities/external-links-target-blank.js'
import konamiCode from './utilities/konami-code.js'

require('../../components/atoms/audio-fragment/audio-fragment.js')
require('../../components/atoms/disclosure/disclosure.js')
require('../../components/atoms/hubspot-embed/hubspot-embed.js')
require('../../components/atoms/picture/picture.js')
require('../../components/atoms/share-button/share-button.js')
require('../../components/atoms/video-embed/video-embed.js')
require('../../components/molecules/form/form.js')
require('../../components/molecules/pagination/paginations.js')
require('../../components/organisms/article-content/article-content.js')
require('../../components/organisms/article-cookies/article-cookies.js')
require('../../components/organisms/article-embed-bamboohr/article-embed-bamboohr.js')
require('../../components/organisms/article-footer/article-footer.js')
require('../../components/organisms/article-form/article-form.js')
require('../../components/organisms/article-header/article-header.js')
require('../../components/organisms/article-photo/article-photo.js')
require('../../components/organisms/article-pills/article-pills.js')
require('../../components/organisms/article-quote/article-quote.js')
require('../../components/organisms/article-video-embed/article-video-embed.js')
require('../../components/organisms/card-grid/card-grid.js')
require('../../components/organisms/home-header/home-header.js')
require('../../components/organisms/home-panel/home-panel.js')
require('../../components/organisms/image-carousel/image-carousel.js')
require('../../components/organisms/image-header/image-header.js')
require('../../components/organisms/lifecycle-carousel/lifecycle-carousel.js')
require('../../components/organisms/logo-marquee/logo-marquee.js')
require('../../components/organisms/newsletter-form/newsletter-form.js')
require('../../components/organisms/request-demo-form/request-demo-form.js')
require('../../components/organisms/testimonial-quote/testimonial-quote.js')
require('../../components/structures/cookie-bar/cookie-bar.js')
require('../../components/structures/footer-bar/footer-bar.js')
require('../../components/structures/menu-bar/menu-bar.js')
require('../../components/structures/menu-overlay/menu-overlay.js')
require('../../components/structures/search-list/search-list.js')
require('../../components/structures/skip-to-main/skip-to-main.js')

// There are 4 load events:
// - 'init-immediate': (compiles when the script is loaded; blocks rendering)
// - 'init-load': (on DOMContentLoaded event; does not block rendering)
// - 'init-after-load': (on Load event, slightly after DOMContentLoaded)
// - 'init-delayed-load': (after Load event, with a slight delay, for iframes and such)
// Usually, the 'init-load' event will suffice.
window.dispatchEvent(new CustomEvent('init-immediate'))
window.addEventListener('DOMContentLoaded', () => window.dispatchEvent(new CustomEvent('init-load')))
window.addEventListener('load', () => window.dispatchEvent(new CustomEvent('init-after-load')))
window.addEventListener('load', () => window.setTimeout(() => window.dispatchEvent(new CustomEvent('init-delayed-load')), 500))

// Focus stuff
document.addEventListener('keydown', () => document.documentElement.classList.add('key-pressed'))
document.addEventListener('mousedown', () => document.documentElement.classList.remove('key-pressed'))
document.addEventListener('touchstart', () => document.documentElement.classList.remove('key-pressed'))

// loading="lazy" polyfill (~3kB) - for non-Chrome
if (!('loading' in HTMLImageElement.prototype)) {
  require('loading-attribute-polyfill')
}

// Import smooth scroll (~35kB) - for Safari and Edge
if (!('scrollBehavior' in document.documentElement.style)) {
  const smoothscroll = require('smoothscroll-polyfill')
  smoothscroll.polyfill()
}

if (window.navigator.userAgent.indexOf('Safari') !== -1) {
  // Web animations polyfill ~(50kB) - for Safari and Edge
  // About 50kb raw, so only use if you need it.
  // const x = import('web-animations-js')
}

if (window.navigator.userAgent.match(/(iOS|Android)+/gi) === null) {
  setAllExternalLinksToTargetBlank(['smartocto.com'])
}

console.log('\n %cMade with %c♥%c by Fabrique \n', 'font: 16px serif;', 'font: 13px serif; color: #f00;', 'font: 16px serif;')

const doConfetti = function (canvas) {
  // start blatant copy paste from a codepen
  const NUM_CONFETTI = 128
  const COLORS = [
    [96, 212, 232],
    [98, 212, 111],
    [255, 178, 0],
    [255, 124, 2],
    [254, 0, 78],
    [255, 0, 157],
    [174, 40, 251],
    [119, 0, 255]
  ]
  const PI_2 = 2 * Math.PI
  const context = canvas.getContext('2d')

  let w = canvas.width = window.innerWidth
  let h = canvas.height = window.innerHeight

  const resizeWindow = function () {
    w = canvas.width = window.innerWidth
    h = canvas.height = window.innerHeight
  }

  window.addEventListener('resize', resizeWindow.bind(this))

  window.onload = function () {
    return setTimeout(resizeWindow.bind(this), 0)
  }

  const range = function (a, b) {
    return (b - a) * Math.random() + a
  }

  const drawCircle = function (x, y, r, style) {
    context.beginPath()
    context.arc(x, y, r, 0, PI_2, false)
    context.fillStyle = style
    context.fill()
  }

  let xpos = 0.5

  document.onmousemove = function (e) {
    xpos = e.pageX / w
  }

  const Confetti = (function () {
    function Confetti () {
      this.style = COLORS[~~range(0, 8)]
      this.rgb = `rgba(${this.style[0]},${this.style[1]},${this.style[2]}`
      this.r = ~~range(2, 6)
      this.r2 = 2 * this.r
      this.replace()
    }

    Confetti.prototype.replace = function () {
      this.opacity = 0
      this.dop = 0.03 * range(1, 4)
      this.x = range(-this.r2, w - this.r2)
      this.y = range(-20, h - this.r2)
      this.xmax = w - this.r
      this.ymax = h - this.r
      this.vx = range(0, 2) + 8 * xpos - 5
      this.vy = 0.7 * this.r + range(-1, 1)
    }

    Confetti.prototype.draw = function () {
      var _ref
      this.x += this.vx
      this.y += this.vy
      this.opacity += this.dop
      if (this.opacity > 1) {
        this.opacity = 1
        this.dop *= -1
      }
      if (this.opacity < 0 || this.y > this.ymax) {
        this.replace()
      }
      if (!(((_ref = this.x) > 0 && _ref < this.xmax))) {
        this.x = (this.x + this.xmax) % this.xmax
      }
      drawCircle(~~this.x, ~~this.y, this.r, `${this.rgb},${this.opacity}`)
    }

    return Confetti
  })()

  const confetti = (function () {
    let _i
    const _results = []

    for (_i = 1; NUM_CONFETTI >= 1 ? _i <= NUM_CONFETTI : _i >= NUM_CONFETTI; _i = NUM_CONFETTI >= 1 ? ++_i : --_i) {
      _results.push(new Confetti())
    }

    return _results
  })()

  const step = function () {
    let c
    let _i
    let _len

    requestAnimationFrame(step)
    context.clearRect(0, 0, w, h)

    const _results = []

    for (_i = 0, _len = confetti.length; _i < _len; _i++) {
      c = confetti[_i]
      _results.push(c.draw())
    }
    return _results
  }

  step()
}

const doKonamiCode = () => {
  const canvas = document.querySelector('#konami-canvas') || document.documentElement.appendChild(document.createElement('canvas'))

  canvas.id = 'konami-canvas'
  canvas.style.position = 'fixed'
  canvas.style.top = 0
  canvas.style.left = 0
  canvas.style.width = '100%'
  canvas.style.height = '100%'
  canvas.style.pointerEvents = 'none'
  canvas.style.background = 'transparent'
  canvas.style.zIndex = 16384

  doConfetti(canvas)
}

konamiCode(() => doKonamiCode())

const logo = document.querySelector('.logo')

if (logo) {
  let count = 0
  let timeout

  logo.addEventListener('mouseenter', () => {
    clearTimeout(timeout)
    timeout = setTimeout(() => count++, 350)
  })

  logo.addEventListener('mouseleave', () => {
    clearTimeout(timeout)

    if (count > 19) {
      doKonamiCode()
    }
  })
}
